export const themeOptionFactory = (theme) => ({
  assets: {},
  components: {
    VuiDetailCard: {
      styleOverrides: {
        image: {
          maxHeight: "40vh",
        },
        infoListWrapper: {
          padding: 0,
          display: "flex",
          flexDirection: "column",
          "& .MuiListItemAvatar-root": {
            minWidth: "58px",
          },
        },
      },
    },
  },
})
